module.exports = __webpack_public_path__ + "static/media/sagah-icon.0317a88b.svg";